import cn from 'classnames'

import { HomepageTable } from '~/components/data-display/tables/homepage/Table'
import { HomepageHeader } from '~/components/pages/homepage/header/Header'

import { HomepageAbout } from '~/components/pages/homepage/About'
import { HomepagePrivacyMethods } from '~/components/pages/homepage/PrivacyMethods'

export function Homepage ()
{
    return (
        <div className={cn('h-full', 'max-w-8xl mx-auto flex flex-col gap-4 justify-start items-stretch')}>
            <HomepageHeader />

            <HomepageTable />

            <HomepageAbout />

            <HomepagePrivacyMethods />
        </div>
    )
}